
import { translations } from '@/translations';
import type { FixSession, Language } from './types';

export class TranslationFileGenerator {
  public generateUpdatedTranslationFiles(session: FixSession): {[key: string]: string} {
    const files: {[key: string]: string} = {};

    // Group fixes by language
    const fixesByLanguage = new Map<Language, Array<{keyPath: string, value: string}>>();
    
    session.appliedFixes.forEach((value, key) => {
      const [language, ...keyParts] = key.split('.');
      const keyPath = keyParts.join('.');
      
      // Ensure value is a string and not empty
      if (typeof value === 'string' && value.trim()) {
        if (!fixesByLanguage.has(language as Language)) {
          fixesByLanguage.set(language as Language, []);
        }
        
        fixesByLanguage.get(language as Language)?.push({ keyPath, value });
      }
    });

    // Generate updated files for each language
    fixesByLanguage.forEach((fixes, language) => {
      try {
        const currentTranslations = translations[language];
        const updatedTranslations = this.applyFixesToTranslationObject(
          JSON.parse(JSON.stringify(currentTranslations)), 
          fixes
        );
        
        files[`${language}.json`] = JSON.stringify(updatedTranslations, null, 2);
      } catch (error) {
        console.error(`Could not generate updated ${language} translations:`, error);
      }
    });

    return files;
  }

  private applyFixesToTranslationObject(obj: unknown, fixes: Array<{keyPath: string, value: string}>): unknown {
    if (typeof obj !== 'object' || obj === null) {
      return obj;
    }

    const result = { ...obj as Record<string, unknown> };
    
    fixes.forEach(fix => {
      this.setNestedValue(result, fix.keyPath, fix.value);
    });
    
    return result;
  }

  private setNestedValue(obj: Record<string, unknown>, path: string, value: string): void {
    const keys = path.split('.');
    let current: Record<string, unknown> = obj;
    
    for (let i = 0; i < keys.length - 1; i++) {
      const key = keys[i];
      if (!(key in current) || typeof current[key] !== 'object' || current[key] === null) {
        current[key] = {};
      }
      current = current[key] as Record<string, unknown>;
    }
    
    current[keys[keys.length - 1]] = value;
  }
}
